import api from "../utils/apiClient";

export const reconcileOrder = async (orderId, configId) => {
    const response = await api.post(
        '/api/reconcile/order',
        { orderId, appConfig: configId },
        { headers: { 'Content-Type': 'application/json' } }
    );
    return response.data;
}
